import React from "react";
import SacriLogo from "src/components/atoms/logo/SacriLogo";
import styled from "styled-components";
import StyleConfig from "src/constants/StyleConfig";
import { ArrowLeftIcon } from "src/components/atoms/icon/ArrowIcon";
import Burger from "src/components/molecules/burger/HambugerMenu";

interface Props {
  goBackAction: Function;
  logoClickAction: Function;
  isMenuOpen: boolean;
  toggleMenuOpen: Function;
}

const HeaderBar = ({ ...props }: Props) => {
  return (
    <Header>
      <div className="inner">
        <div
          className="prev"
          onClick={() => {
            props.toggleMenuOpen(false);
            props.goBackAction();
          }}
        >
          <ArrowLeftIcon color={"primary"} />
        </div>
        <div
          className="logo"
          onClick={() => {
            props.logoClickAction();
          }}
        >
          <SacriLogo />
        </div>
        <div className="icon">
          <Burger isOpen={props.isMenuOpen} setOpen={props.toggleMenuOpen} />
        </div>
      </div>
      <div className="inner2">
        <span className="warning">
          旧管理画面は閲覧のみ可能です。登録や編集は新管理画面をご利用ください
        </span>
        <a
          href={
            process.env.REACT_APP_STAGE === "dev"
              ? "https://dev-sacri-admin.web.app/"
              : "https://admin-sacri.web.app/"
          }
          className="warning"
        >
          新管理画面はこちら
        </a>
      </div>
    </Header>
  );
};

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #fff;
  height: 110px;
  z-index: 10;
  .inner {
    font-size: 0;
    height: 52px;
    max-width: ${StyleConfig.SETTING.maxWidth}px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 0 ${StyleConfig.HELPER.M12};
    .prev {
      cursor: pointer;
    }
    .logo {
      margin: 0 auto;
      text-align: center;
      svg {
        cursor: pointer;
      }
    }
    .icon {
      padding-right: ${StyleConfig.HELPER.M12};
    }
  }
  .inner2 {
    flex-direction: column;
    background-color: red;
    font-size: 0;
    height: 58px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${StyleConfig.HELPER.M12};
    .warning {
      text-align: center;
      font-size: 1rem;
      font-weight: 700;
      color: ${StyleConfig.COLOR.WHITE};
    }
  }
`;

export default HeaderBar;
